export const countryValidator = async (rule: any, value: string) => {
  if (value !== 'IE' && value !== 'GB' && value?.length > 0) {
    throw new Error();
  }
};

export const phoneValidator = async (rule: any, phone: string) => {
  if (!phone) {
    return
  }
  const pattern =
    /^[1-9]?[0-9]{7,14}$/
  if (!phone.match(pattern)) {
    throw new Error();
  }
};


export const passwordValidatorPattern =
  /(?=[A-Za-z0-9|^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[|^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=])(?=.{8,}).*$/;
export const passwordValidatorMessage =
  'Minimum length 8 characters, 1 number, 1 lower case, 1 upper case and 1 symbol';